import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Link, Redirect, useHistory, useParams } from "react-router-dom";
import {
  FaBook,
  FaCalendarAlt,
  FaCheckCircle,
  FaClipboardList,
  FaEye,
  FaFileAlt,
  FaSyncAlt,
  FaUsers,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import BackButton from "../ChildComponent/BackButton";
import MdlSelectSession from "../dialog/MdlSelectSession";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

//Created By Cursor
function classLabel(item) {
  if (!item) return "Class";
  if (
    item.section_id === "No" ||
    item.section_id === "null" ||
    !item.section_name
  ) {
    return item.class_name || "Class";
  }
  return `${item.class_name}:${item.section_name}`;
}

const MarkEntryForm = () => {
  const history = useHistory();
  const { document_type } = useParams();

  const loggedIn = localStorage.getItem("token") !== null;
  const [bootLoading, setBootLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE, setDOCUMENT_TYPE] = useState("");
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [CLASS_SECTION_NAME, setCLASS_SECTION_NAME] = useState("");

  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [mExamList, setMExamList] = useState([]);
  const [CLASS_ID, setCLASS_ID] = useState("");
  const [SECTION_ID, setSECTION_ID] = useState("");
  const [EXAM_ID, setEXAM_ID] = useState("");
  const [EXAM_NAME, setEXAM_NAME] = useState("");
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [SESSION_STATUS, setSESSION_STATUS] = useState("");
  const [EXAM_SELECTED_POSITION, setEXAM_SELECTED_POSITION] = useState(0);
  const [mClassList, setMClassList] = useState([]);
  const [selectedClassIndex, setSelectedClassIndex] = useState(-1);
  const [SUJECT_SELECTED_POSITION, setSUJECT_SELECTED_POSITION] = useState(-1);
  const [mSubject, setMSubject] = useState([]);
  const [selected_subject_id, setSelected_subject_id] = useState("");
  const [selected_subject_name, setSelected_subject_name] = useState("");
  const [iFrameHeight, setIFrameHeight] = useState("0px");

  const selectClassRef = useRef(null);
  const getSubjectRef = useRef(null);
  const getPrintableSamplesRef = useRef(null);
  const setFileUrLRef = useRef(null);
  const setSampleRef = useRef(null);
  const iframeRef = useRef(null);
  const bootDoneRef = useRef(false);

  const selectedClass = useMemo(
    () =>
      selectedClassIndex >= 0 && mClassList[selectedClassIndex]
        ? mClassList[selectedClassIndex]
        : null,
    [selectedClassIndex, mClassList]
  );

  const sessionActive = useMemo(() => {
    const s = String(SESSION_STATUS || "").toLowerCase();
    return s === "active" || s === "1";
  }, [SESSION_STATUS]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setIFrameHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  //Created By Cursor — init session + document type from route
  useEffect(() => {
    window.scrollTo(0, 0);
    setDOCUMENT_TYPE(document_type);
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession[0]) {
      setSESSION_ID(mSession[0].session_id);
      setSESSION_NAME(mSession[0].session_name);
      setSESSION_STATUS(mSession[0].status);
    } else {
      setBootLoading(false);
    }
  }, [document_type]);

  //Created By Cursor
  const getExamList = useCallback(
    (opts = {}) => {
      if (!SESSION_ID) return;
      const soft = !!opts.soft;
      if (soft) setRefreshing(true);
      else setLoading(true);

      const SCHOOL_CODE = SessionManager.getSchoolCode();
      axios
        .get(`${API_BASE()}getExamListLite.php`, {
          params: {
            school_code: SCHOOL_CODE,
            session_id: SESSION_ID,
          },
        })
        .then((res) => res.data)
        .then((response) => {
          if (soft) setRefreshing(false);
          else setLoading(false);
          if (!bootDoneRef.current) {
            bootDoneRef.current = true;
            setBootLoading(false);
          }
          if (response.api_status === "OK") {
            const exams = response.data || [];
            setMExamList(exams);
            if (exams.length > 0) {
              const first = exams[EXAM_SELECTED_POSITION] || exams[0];
              setEXAM_ID(first.exam_id);
              setEXAM_NAME(first.exam_name);
            } else {
              setEXAM_ID("");
              setEXAM_NAME("");
            }
          } else {
            myToast.notify_warning(response.api_remark);
          }
        })
        .catch((error) => {
          if (soft) setRefreshing(false);
          else setLoading(false);
          if (!bootDoneRef.current) {
            bootDoneRef.current = true;
            setBootLoading(false);
          }
          console.error("Error fetching exam list:", error);
        });
    },
    [SESSION_ID, EXAM_SELECTED_POSITION]
  );

  useEffect(() => {
    if (SESSION_ID) {
      getExamList();
    }
  }, [SESSION_ID, getExamList]);

  //Created By Cursor
  const getClassWithSubjectsPartAndPaper = useCallback(
    (examIdParam) => {
      if (!SESSION_ID || !examIdParam) return;
      setLoading(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      axios
        .get(`${API_BASE()}getClassWithSubjectsPartAndPaper.php`, {
          params: {
            school_code: SCHOOL_CODE,
            exam_id: examIdParam,
            session_id: SESSION_ID,
          },
        })
        .then((res) => res.data)
        .then((response) => {
          setLoading(false);
          if (response.api_status === "OK") {
            const classList = response.data || [];
            setMClassList(classList);
            if (Array.isArray(classList) && classList.length > 0) {
              if (selectClassRef.current) {
                selectClassRef.current(0);
              }
            } else {
              setSelectedClassIndex(-1);
              setMSubject([]);
              setCLASS_ID("");
              setSECTION_ID("");
              setCLASS_SECTION_NAME("");
            }
          } else {
            myToast.notify_warning(response.api_remark);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching classes:", error);
        });
    },
    [SESSION_ID]
  );

  useEffect(() => {
    if (EXAM_ID && SESSION_ID) {
      getClassWithSubjectsPartAndPaper(EXAM_ID);
    }
  }, [EXAM_ID, SESSION_ID, getClassWithSubjectsPartAndPaper]);

  //Created By Cursor
  const ChangeSession = useCallback(() => {
    setIsOpenSessionDialog(true);
  }, []);

  //Created By Cursor
  const HandleCloseSessionDialog = useCallback(() => {
    setIsOpenSessionDialog(false);
  }, []);

  //Created By Cursor
  const HandleSelectedSession = useCallback(
    (session_id, session_name, session_status) => {
      bootDoneRef.current = false;
      setBootLoading(true);
      setSESSION_ID(session_id);
      setSESSION_NAME(session_name);
      setSESSION_STATUS(session_status);
      setIsOpenSessionDialog(false);
      setEXAM_SELECTED_POSITION(0);
      setFILE_NAME("");
      setFILE_DIRECTORY("");
      setSELECTED_SAMPLE_ID("");
      setMPrintableSamples([]);
      setFILE_URL("");
    },
    []
  );

  //Created By Cursor
  const SelectExam = useCallback((exam_id, exam_name, position) => {
    setEXAM_ID(exam_id);
    setEXAM_NAME(exam_name);
    setEXAM_SELECTED_POSITION(position);
    setFILE_NAME("");
    setFILE_DIRECTORY("");
    setSELECTED_SAMPLE_ID("");
    setMPrintableSamples([]);
    setFILE_URL("");
  }, []);

  //Created By Cursor
  const selectClass = useCallback(
    (position) => {
      if (position >= 0 && mClassList[position]) {
        const selected = mClassList[position];
        setCLASS_ID(selected.class_id);
        const normalizedSectionId =
          selected.section_id === "null" ? "No" : selected.section_id;
        setSECTION_ID(normalizedSectionId);
        setSelectedClassIndex(position);
        setCLASS_SECTION_NAME(classLabel(selected));
        setSUJECT_SELECTED_POSITION(-1);
        setSelected_subject_id("");
        setSelected_subject_name("");
        setFILE_URL("");
        if (getSubjectRef.current) {
          getSubjectRef.current(-1, position);
        }
      }
    },
    [mClassList]
  );
  selectClassRef.current = selectClass;

  //Created By Cursor
  const getSubject = useCallback(
    (selected_position_subject, classIndex) => {
      const index = classIndex ?? selectedClassIndex;
      const subjects = (mClassList[index] && mClassList[index].subject) || [];
      setMSubject(subjects || []);

      if (selected_position_subject >= 0) {
        if (
          subjects &&
          subjects.length > 0 &&
          selected_position_subject < subjects.length
        ) {
          const selectedSubject = subjects[selected_position_subject];
          setSUJECT_SELECTED_POSITION(selected_position_subject);
          setSelected_subject_id(selectedSubject.subject_id);
          setSelected_subject_name(selectedSubject.subject_name);

          if (!mPrintableSamples || mPrintableSamples.length === 0) {
            if (getPrintableSamplesRef.current) {
              getPrintableSamplesRef.current(
                selectedSubject.subject_id,
                selectedSubject.subject_name
              );
            }
          } else if (setFileUrLRef.current) {
            setFileUrLRef.current(
              selectedSubject.subject_id,
              selectedSubject.subject_name
            );
          }
        } else {
          setSUJECT_SELECTED_POSITION(-1);
          setSelected_subject_id("");
          setSelected_subject_name("");
          setMSubject([]);
        }
      } else {
        setSUJECT_SELECTED_POSITION(-1);
        setMSubject([...subjects]);
      }
    },
    [selectedClassIndex, mClassList, mPrintableSamples]
  );
  getSubjectRef.current = getSubject;

  //Created By Cursor
  const getPrintableSamples = useCallback(
    (pendingSubjectId = null, pendingSubjectName = null) => {
      if (!DOCUMENT_TYPE) return;
      setLoading(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      axios
        .get(`${API_BASE()}getPrintableSample.php`, {
          params: {
            school_code: SCHOOL_CODE,
            document_type: DOCUMENT_TYPE,
          },
        })
        .then((res) => res.data)
        .then((response) => {
          setLoading(false);
          if (response.api_status === "OK") {
            const samples = response.data || [];
            setMPrintableSamples(samples);
            if (setSampleRef.current) {
              setSampleRef.current(
                samples,
                pendingSubjectId,
                pendingSubjectName
              );
            }
          } else {
            myToast.notify_warning(response.api_remark);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching printable samples:", error);
        });
    },
    [DOCUMENT_TYPE]
  );
  getPrintableSamplesRef.current = getPrintableSamples;

  //Created By Cursor
  const setFileUrLWithValues = useCallback(
    (
      fileName,
      fileDirectory,
      sampleId,
      subjectId,
      subjectName,
      examId,
      examName
    ) => {
      if (!fileDirectory || !fileName) return;

      const SCHOOL_CODE = SessionManager.getSchoolCode();
      let url = process.env.REACT_APP_SERVER_NAME + fileDirectory + fileName;
      url += "?class_id=" + encodeURIComponent(CLASS_ID || "");
      url += "&section_id=" + encodeURIComponent(SECTION_ID || "");
      url +=
        "&class_section_name=" + encodeURIComponent(CLASS_SECTION_NAME || "");
      url += "&session_id=" + encodeURIComponent(SESSION_ID || "");
      url += "&exam_id=" + encodeURIComponent(examId || "");
      url += "&exam_name=" + encodeURIComponent(examName || "");
      url += "&subject_id=" + encodeURIComponent(subjectId || "");
      url += "&subject_name=" + encodeURIComponent(subjectName || "");
      url += "&sample_id=" + encodeURIComponent(sampleId || "");
      url +=
        "&system_code=" +
        encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE || "");
      url += "&school_code=" + encodeURIComponent(SCHOOL_CODE || "");

      if (process.env.NODE_ENV === "development") {
        console.log("FILE_URL", url);
      }
      setFILE_URL(url);
    },
    [CLASS_ID, SECTION_ID, CLASS_SECTION_NAME, SESSION_ID]
  );

  //Created By Cursor
  const setSample = useCallback(
    (samples, pendingSubjectId = null, pendingSubjectName = null) => {
      const list = samples || mPrintableSamples;
      if (!list || list.length === 0) return;

      const first = list[0];
      const fileName = first.file_name || "";
      const fileDirectory = first.file_directory || "";
      const sampleId = first.sample_id || "";

      setFILE_NAME(fileName);
      setFILE_DIRECTORY(fileDirectory);
      setSELECTED_SAMPLE_ID(sampleId);

      const subjectIdToUse =
        pendingSubjectId !== null ? pendingSubjectId : selected_subject_id;
      const subjectNameToUse =
        pendingSubjectName !== null
          ? pendingSubjectName
          : selected_subject_name;

      setFileUrLWithValues(
        fileName,
        fileDirectory,
        sampleId,
        subjectIdToUse,
        subjectNameToUse,
        EXAM_ID,
        EXAM_NAME
      );
    },
    [
      mPrintableSamples,
      selected_subject_id,
      selected_subject_name,
      EXAM_ID,
      EXAM_NAME,
      setFileUrLWithValues,
    ]
  );
  setSampleRef.current = setSample;

  //Created By Cursor
  const setFileUrL = useCallback(
    (subjectIdParam = null, subjectNameParam = null) => {
      if (!FILE_DIRECTORY || !FILE_NAME) return;

      const subjectId =
        subjectIdParam !== null ? subjectIdParam : selected_subject_id;
      const subjectName =
        subjectNameParam !== null ? subjectNameParam : selected_subject_name;

      setFileUrLWithValues(
        FILE_NAME,
        FILE_DIRECTORY,
        SELECTED_SAMPLE_ID,
        subjectId,
        subjectName,
        EXAM_ID,
        EXAM_NAME
      );
    },
    [
      FILE_DIRECTORY,
      FILE_NAME,
      SELECTED_SAMPLE_ID,
      selected_subject_id,
      selected_subject_name,
      EXAM_ID,
      EXAM_NAME,
      setFileUrLWithValues,
    ]
  );
  setFileUrLRef.current = setFileUrL;

  //Created By Cursor
  const handleIframeLoad = useCallback(() => {
    setShowPreview(false);
  }, []);

  //Created By Cursor
  const handleIframeError = useCallback(() => {
    setShowPreview(false);
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to load iframe:", FILE_URL);
    }
  }, [FILE_URL]);

  useEffect(() => {
    if (FILE_URL) {
      setShowPreview(true);
      const timeout = setTimeout(() => {
        setShowPreview(false);
      }, 2000);
      return () => clearTimeout(timeout);
    }
    setShowPreview(false);
  }, [FILE_URL]);

  if (!loggedIn) return <Redirect to="/Login" />;
  if (bootLoading) return <MyLoader />;

  const stepExamDone = !!EXAM_ID;
  const stepClassDone = selectedClassIndex >= 0;
  const stepSubjectDone = SUJECT_SELECTED_POSITION >= 0;

  return (
    <div
      className="content payroll-page sm-page mef-page"
      style={{ fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <Link to="/AdminMain/ExamList" style={{ color: COLORS.white }}>
                {" "}
                Exams
              </Link>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Mark Entry Form</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton onClick={() => history.goBack()} />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
        <header className="sm-hero mef-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon mef-hero__icon" aria-hidden>
              <FaClipboardList />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Mark Entry Form</h1>
              <p className="sm-hero__sub">
                Printable blank mark sheet — select exam, class & subject
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <button
              type="button"
              className="mef-session-pill"
              onClick={ChangeSession}
              title="Change session"
            >
              <FaCalendarAlt aria-hidden />
              <span className="mef-session-pill__copy">
                <span className="mef-session-pill__label">Session</span>
                <span className="mef-session-pill__name">
                  {SESSION_NAME || "Select"}
                </span>
              </span>
              {SESSION_STATUS ? (
                <span
                  className={`mef-session-pill__status${
                    sessionActive ? " is-active" : ""
                  }`}
                >
                  {SESSION_STATUS}
                </span>
              ) : null}
            </button>
            <button
              type="button"
              onClick={() => getExamList({ soft: true })}
              disabled={refreshing || !SESSION_ID}
              className={`pp-icon-btn mef-refresh-btn${
                refreshing ? " spinning" : ""
              }`}
              title="Refresh"
              aria-label="Refresh"
            >
              <FaSyncAlt aria-hidden />
            </button>
          </div>
        </header>

        {isOpenSessionDialog ? (
          <MdlSelectSession
            action={HandleCloseSessionDialog}
            action2={HandleSelectedSession}
          />
        ) : null}

        <div className="mef-content">
          <nav className="mef-steps" aria-label="Selection progress">
            <span
              className={`mef-step${stepExamDone ? " is-done" : " is-current"}`}
            >
              <span className="mef-step__num">1</span>
              Exam
            </span>
            <span className="mef-steps__line" aria-hidden />
            <span
              className={`mef-step${
                stepClassDone
                  ? " is-done"
                  : stepExamDone
                  ? " is-current"
                  : ""
              }`}
            >
              <span className="mef-step__num">2</span>
              Class
            </span>
            <span className="mef-steps__line" aria-hidden />
            <span
              className={`mef-step${
                stepSubjectDone
                  ? " is-done"
                  : stepClassDone
                  ? " is-current"
                  : ""
              }`}
            >
              <span className="mef-step__num">3</span>
              Subject
            </span>
            <span className="mef-steps__line" aria-hidden />
            <span
              className={`mef-step${
                FILE_URL ? " is-done" : stepSubjectDone ? " is-current" : ""
              }`}
            >
              <span className="mef-step__num">4</span>
              Preview
            </span>
          </nav>

          {loading ? (
            <div className="mef-loading-inline" aria-live="polite">
              <MyLoader />
            </div>
          ) : null}

          <section
            className="mef-section-card mef-section-card--exam"
            aria-label="Select exam"
          >
            <div className="mef-section-card__header">
              <h2 className="mef-section-card__title">
                <span className="mef-section-card__icon" aria-hidden>
                  <FaFileAlt />
                </span>
                <span>Select Exam</span>
              </h2>
            </div>
            <div className="mef-section-card__body">
              {mExamList.length === 0 ? (
                <div className="mef-empty">
                  <p className="mef-empty__title">No exams for this session</p>
                  <p className="mef-empty__hint">
                    Change session or create an exam first.
                  </p>
                </div>
              ) : (
                <div className="mef-chip-grid">
                  {mExamList.map((item, index) => {
                    const isSelected = EXAM_SELECTED_POSITION === index;
                    return (
                      <button
                        key={`exam-${item.exam_id}-${index}`}
                        type="button"
                        className={`mef-chip${isSelected ? " is-active" : ""}`}
                        onClick={() =>
                          SelectExam(item.exam_id, item.exam_name, index)
                        }
                      >
                        {isSelected ? <FaCheckCircle aria-hidden /> : null}
                        {item.exam_name}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          </section>

          <section
            className="mef-section-card mef-section-card--class"
            aria-label="Select class"
          >
            <div className="mef-section-card__header">
              <h2 className="mef-section-card__title">
                <span className="mef-section-card__icon" aria-hidden>
                  <FaUsers />
                </span>
                <span>Participating Class</span>
              </h2>
            </div>
            <div className="mef-section-card__body">
              {mClassList.length === 0 ? (
                <div className="mef-empty">
                  <p className="mef-empty__title">No participating classes</p>
                  <p className="mef-empty__hint">
                    Select an exam that has classes linked.
                  </p>
                </div>
              ) : (
                <div className="mef-chip-grid">
                  {mClassList.map((item, index) => (
                    <button
                      key={`class-${item.class_id}-${index}`}
                      type="button"
                      className={`mef-chip${
                        selectedClassIndex === index ? " is-active" : ""
                      }`}
                      onClick={() => selectClass(index)}
                    >
                      {classLabel(item)}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </section>

          <section
            className="mef-section-card mef-section-card--subject"
            aria-label="Select subject"
          >
            <div className="mef-section-card__header">
              <h2 className="mef-section-card__title">
                <span className="mef-section-card__icon" aria-hidden>
                  <FaBook />
                </span>
                <span>Participating Subject</span>
                {selectedClass ? (
                  <span className="mef-section-card__meta">
                    {classLabel(selectedClass)}
                  </span>
                ) : null}
              </h2>
            </div>
            <div className="mef-section-card__body">
              {mSubject.length === 0 ? (
                <div className="mef-empty mef-empty--compact">
                  <p className="mef-empty__title">Select a class first</p>
                </div>
              ) : (
                <div className="mef-chip-grid">
                  {mSubject.map((item2, index2) => (
                    <button
                      key={`subject-${item2.subject_id}-${index2}`}
                      type="button"
                      className={`mef-chip mef-chip--subject${
                        SUJECT_SELECTED_POSITION === index2 ? " is-active" : ""
                      }`}
                      onClick={() => getSubject(index2)}
                    >
                      {item2.subject_name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </section>

          <section
            className="mef-section-card mef-section-card--preview"
            aria-label="Form preview"
          >
            <div className="mef-section-card__header">
              <h2 className="mef-section-card__title">
                <span className="mef-section-card__icon" aria-hidden>
                  <FaEye />
                </span>
                <span>Preview</span>
              </h2>
              {selected_subject_name ? (
                <div className="mef-preview-trail">
                  {EXAM_NAME ? (
                    <span className="mef-preview-trail__item">{EXAM_NAME}</span>
                  ) : null}
                  {CLASS_SECTION_NAME ? (
                    <span className="mef-preview-trail__item">
                      {CLASS_SECTION_NAME}
                    </span>
                  ) : null}
                  <span className="mef-preview-trail__item is-focus">
                    {selected_subject_name}
                  </span>
                </div>
              ) : null}
            </div>
            <div className="mef-section-card__body mef-section-card__body--preview">
              <div className="mef-preview-frame">
                {!FILE_URL ? (
                  <div className="mef-empty mef-empty--preview">
                    <div className="mef-empty__badge" aria-hidden>
                      <FaFileAlt />
                    </div>
                    <p className="mef-empty__title">
                      Select a subject to preview
                    </p>
                    <p className="mef-empty__hint">
                      Exam → Class → Subject builds the printable mark entry
                      form.
                    </p>
                  </div>
                ) : showPreview ? (
                  <div className="mef-loading-inline mef-loading-inline--preview">
                    <div className="mef-spinner" aria-hidden />
                    <p className="mef-empty__title">Loading preview…</p>
                  </div>
                ) : (
                  <Iframe
                    ref={iframeRef}
                    key={FILE_URL}
                    url={FILE_URL}
                    width="100%"
                    height={iFrameHeight}
                    overflow="auto"
                    id="iFrame1"
                    display="initial"
                    position="relative"
                    scrolling="no"
                    className="mef-iframe"
                    onLoad={handleIframeLoad}
                    onError={handleIframeError}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MarkEntryForm;
